import React, { useEffect, useState } from "react";
import NoSearch from "./NoSearch";
import RadioCard from "pages/radioPage/shared/RadioCard";

function SearchRadioSection({ data, user }: any) {
  const stations = data?.radio_stations || [];
  // const [stations, setStations] = useState<any>([]);

  // useEffect(() => {
  //   if (data) {
  //     setStations(data.radio_stations);
  //   }
  // }, [data]);

  return (
    <div>
      {/* top section */}
      <div className="mb-8 w-[98%] ml-2 mt-8 max-sm:w-full max-sm:mx-0">
        <div>
          <h1 className="text-xl font-semibold text-white lg:text-xl md:text-xl max-sm:ml-3">
            {/* search radios */}
            Radios
          </h1>
        </div>
      </div>
      {/* card section */}
      {stations.length === 0 && stations ? (
        <NoSearch text="Radios" />
      ) : (
        <div>
          <div className="mt-4 mb-5 w-[95%] grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-6 max-sm:mx-auto max-sm:w-full max-sm:gap-4 max-sm:ml-3">
            {stations.length > 0 &&
              stations.map((station: any, i: any) => (
                <div key={i}>
                  <RadioCard station={station} user={user} />
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default SearchRadioSection;
